import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "../../../components/Sidebar";
import TopBar from "../../../components/TopBar";
import "./index.css";
import { Grid, Box } from "@mui/material";
import {
  Card,
  Space,
  Button,
  Tag,
  Modal,
  Form,
  Input,
  Switch,
  message,
} from "antd";
import Table from "../../../../common/components/Table";
import { RxDownload } from "react-icons/rx";
import { useDispatch, useSelector } from "react-redux";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { getRiskStudent } from "../../../api/Risk/RiskStudentSlice";
import DashboardCounter from "../../Dashboard/DashboardCounter";
import dash_user from "../../../../../assets/images/high.png";
import dash_pract from "../../../../../assets/images/mod.png";
import low_risk from "../../../../../assets/images/low.png";
import high_risk from "../../../../../assets/images/high_risk.png";
import active_user from "../../../../../assets/images/active_user.png";
import inactive_user from "../../../../../assets/images/inactive_user.png";

export default function Index() {
  const dispatch = useDispatch();
  const [collapsed, setCollapsed] = useState(false);
  const [totalStudent, setTotal] = useState(0);
  const [activeStudent, setActive] = useState(0);
  const [inactive, setInactive] = useState(0);
  const [high, sethigh] = useState(0);
  const [Moderate, setModerate] = useState(0);
  const [low, setLow] = useState(0);
  const [no, setNo] = useState(0);
  const [list, setList] = useState([]);
  const [col, setCol] = useState([
    {
      title: "Name",
      key: "name",
      render: (_, record) => <span className="table-item">{_.firstName}</span>,
    },
    {
      title: "Email ID",
      key: "email",
      render: (_, record) => <span className="table-item">{_.email}</span>,
    },
    {
      title: "Practitioner Name",
      key: "pract_name",
      render: (_, record) => (
        <span className="table-item">Dr.{_.counsellorName}</span>
      ),
    },
    {
      title: "Practitioner Email",
      key: "pract_email",
      render: (_, record) => (
        <span className="table-item">{_.counsellorEmail}</span>
      ),
    },
    {
      title: "Status",
      key: "status",
      render: (_, record) => <>{getTags(_.riskStatus)}</>,
    },
  ]);
  const getTags = (item) => {
    if (item === "NO_RISK") {
      return <Tag color="green">No Risk</Tag>;
    } else if (item === "LOW_RISK") {
      return (
        <Tag color="yellow" style={{ color: "#000" }}>
          Low Risk
        </Tag>
      );
    } else if (item === "MODERATE_RISK") {
      return <Tag color={"orange"}>Moderate Risk</Tag>;
    } else if (item === "HIGH_RISK") {
      return <Tag color="red">High Risk</Tag>;
    }
  };
  const getStudentListsData = () => {
    let token = localStorage.getItem("token");
    dispatch(getRiskStudent("Bearer " + token)).then((res) => {
      console.log("data===========>", res.payload.data.payload.data);
      if (Array.isArray(res.payload.data.payload.data)) {
        let arr = res.payload.data.payload.data;
        setList(arr);
        let highRisk = arr.filter((item) => item.riskStatus === "HIGH_RISK");
        let modRisk = arr.filter((item) => item.riskStatus === "MODERATE_RISK");
        let lowRisk = arr.filter((item) => item.riskStatus === "LOW_RISK");
        let noRisk = arr.filter((item) => item.riskStatus === "NO_RISK");

        sethigh(highRisk.length);
        setModerate(modRisk.length);
        setLow(lowRisk.length);
        setNo(noRisk.length);
      }
    });
  };
  const downloadList = () => {
    const worksheet = XLSX.utils.json_to_sheet(list);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "TableData");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(data, "table-data.xlsx");
  };

  useEffect(() => {
    getStudentListsData();
  }, []);
  return (
    <div className="fixed inset-x-0 bottom-0 top-16 flex bg-[#F8FAFC] overflow-hidden">
      <TopBar />
      {/* Sidebar */}
      <div
        className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-screen z-20`}
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
      {/* Main Content */}
      <div
        className={`flex-1 min-w-0 overflow-auto bg-[#F8FAFC] pt-2 px-2 pb-8 transition-all duration-300 ${
          collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"
        }`}
      >
        <div className="p-4 md:p-6 bg-[#FFFFFF] min-h-screen rounded-2xl">
          <Container fluid className="px-0">
            <Row>
              <Col md={3}>
                <DashboardCounter
                  mainIcon={high_risk}
                  activeIcon={active_user}
                  inactiveIcon={inactive_user}
                  title={"High Risk"}
                  total={high}
                  subTitleOne={""}
                  subTitleTwo={""}
                  link={"#"}
                  showBottom={false}
                />
              </Col>
              <Col md={3}>
                <DashboardCounter
                  mainIcon={dash_pract}
                  activeIcon={active_user}
                  inactiveIcon={inactive_user}
                  title={"Moderate Risk"}
                  total={Moderate}
                  subTitleOne={""}
                  subTitleTwo={""}
                  link={"#"}
                  showBottom={false}
                />
              </Col>
              <Col md={3}>
                <DashboardCounter
                  mainIcon={low_risk}
                  activeIcon={active_user}
                  inactiveIcon={inactive_user}
                  title={"Low Risk"}
                  total={low}
                  subTitleOne={""}
                  subTitleTwo={""}
                  link={"#"}
                  showBottom={false}
                />
              </Col>
              <Col md={3}>
                <DashboardCounter
                  mainIcon={dash_user}
                  activeIcon={active_user}
                  inactiveIcon={inactive_user}
                  title={"No Risk"}
                  total={no}
                  subTitleOne={""}
                  subTitleTwo={""}
                  link={"#"}
                  showBottom={false}
                />
              </Col>
            </Row>
          </Container>
          <Container fluid className="px-0">
            <Box style={{ marginTop: "8px" }}>
              <Grid
                md={12}
                style={{
                  marginTop: "0px",
                  msOverflowStyle: "none",
                  scrollbarWidth: "0px",
                }}
              >
                <Card
                  title="User Risk List"
                  className="font-poppins rounded-2xl border-[1px] border-solid border-[#E2E8F0] shadow-sm"
                  extra={
                    <Button
                      className="btn-gradient flex items-center gap-2 rounded-xl border-0 h-9 px-[14px] text-[13px] font-semibold font-poppins"
                      onClick={() => downloadList()}
                    >
                      Download <RxDownload color="#FFFFFF" />
                    </Button>
                  }
                  style={{
                    marginTop: "30px",
                    msOverflowStyle: "none",

                    height: "calc(70 * var(--vh))",
                  }}
                >
                  <div style={{ height: "calc(100 * var(--vh))" }}>
                    <Table
                      col={col}
                      placeholder={"Search..."}
                      data={list}
                      showFilter={true}
                    />
                  </div>
                </Card>
              </Grid>
            </Box>
          </Container>
        </div>
      </div>
    </div>
  );
}
